'use client';
import { useEffect, useState } from "react";
import UsersDs from '../../../DataServices/UsersDs';
import { useCustomContext } from "../../CustomComponents/CustomComponents";
import { insertLog } from '../../Logs/InsertLog';

export const ProjectAccessLogic = ({ user, onClose, datasets = [], usersList }) => {

  const useremail = localStorage.getItem("email");
  const { showAlert, hud, showToast, stopHudRotation } = useCustomContext();
  const isEditMode = !!user;
  const emailaddedby = localStorage.getItem("employeeName")

  const [showPassword, setShowPassword] = useState(false);

  const [userState, setUserState] = useState({
    username: "",
    email: "",
    password: "",
    accessLevel: "",
    callAccess: false,
    canView: false,
    canEdit: false,
    projectAccess: {
      "winter-soldier": { enabled: false, datasets: [] },
      "summer-warrior": { enabled: false, datasets: [] },
      "poke-man": { enabled: false }
    }
  });

  const [errors, setErrors] = useState({});
  const usersDS = new UsersDs();

  const isAdmin = JSON.parse(localStorage.getItem("employeeInfo"))?.accessLevel === 1;

  const ACCESS_LEVEL = {
    "0": { label: "Select access", add: 0, update: 0 },
    "1": { label: "Admin", add: 1, update: 1 },
    "2": { label: "Manager", add: 2, update: 2 },
    "3": { label: "Employee", add: 3, update: 3 }
  };

  const normalizeAccessLevel = (value) => {
    if (value === 1 || value === "1") return "1";
    if (value === 2 || value === "2") return "2";
    if (value === 3 || value === "3") return "3";

    if (typeof value === "string") {
      const v = value.toLowerCase();
      if (v === "admin") return "1";
      if (v === "manager") return "2";
      if (v === "employee") return "3";
    }

    return "3";
  };
  const attr = isEditMode ? user.Attributes.find(a => a.Name === "custom:empInfo") : " ";
  const empInfo = JSON.parse(attr.Value || "{}");
  console.log("employee attributes:", empInfo)
  const loadProjectAccess = (user) => {
    try {
      const emptyResult = {
        accessLevel: "",
        callAccess: false,
        canView: false,
        canEdit: false,
        projectAccess: {
          "winter-soldier": { enabled: false, datasets: [] },
          "summer-warrior": { enabled: false, datasets: [] },
          "poke-man": { enabled: false }
        }
      };

      if (!user || !Array.isArray(user.Attributes)) {
        return emptyResult;
      }

      const attr = user.Attributes.find(a => a.Name === "custom:empInfo");
      if (!attr?.Value) {
        return emptyResult;
      }

      const empInfo = JSON.parse(attr.Value || "{}");

      emptyResult.accessLevel = normalizeAccessLevel(empInfo.accessLevel);
      emptyResult.callAccess = !!empInfo.callAccess;
      emptyResult.canView = !!empInfo.canView;
      emptyResult.canEdit = !!empInfo.canEdit;

      // NEW STRUCTURE: Check if projectAccess has nested enabled/datasets
      if (empInfo.projectAccess && typeof empInfo.projectAccess === "object") {
        emptyResult.projectAccess = {
          "winter-soldier": {
            enabled: !!empInfo.projectAccess["winter-soldier"]?.enabled,
            datasets: empInfo.projectAccess["winter-soldier"]?.datasets || []
          },
          "summer-warrior": {
            enabled: !!empInfo.projectAccess["summer-warrior"]?.enabled,
            datasets: empInfo.projectAccess["summer-warrior"]?.datasets || []
          },
          "poke-man": {
            enabled: !!empInfo.projectAccess["poke-man"]?.enabled
          }
        };
      }
      // OLD STRUCTURE: Migrate from flat projectAccess and separate datasetAccess
      else if (empInfo.projectAccess || empInfo.datasetAccess) {
        if (empInfo.projectAccess) {
          emptyResult.projectAccess["winter-soldier"].enabled = !!empInfo.projectAccess["winter-soldier"];
          emptyResult.projectAccess["summer-warrior"].enabled = !!empInfo.projectAccess["summer-warrior"];
          emptyResult.projectAccess["poke-man"].enabled = !!empInfo.projectAccess["poke-man"];
        }

        if (empInfo.datasetAccess) {
          emptyResult.projectAccess["winter-soldier"].datasets = empInfo.datasetAccess["winter-soldier"] || [];
          emptyResult.projectAccess["summer-warrior"].datasets = empInfo.datasetAccess["summer-warrior"] || [];
        }
      }
      // LEGACY STRUCTURE: Migrate from project-access array
      else if (Array.isArray(empInfo["project-access"])) {
        empInfo["project-access"].forEach(entry => {
          if (entry.wintersoldier === true) {
            emptyResult.projectAccess["winter-soldier"].enabled = true;
            emptyResult.projectAccess["winter-soldier"].datasets = entry["datasets"] || [];
          }
          if (entry.summerwarrior === true) {
            emptyResult.projectAccess["summer-warrior"].enabled = true;
            emptyResult.projectAccess["summer-warrior"].datasets = entry["datasets"] || [];
          }
          if (entry["poke-man"] === true) {
            emptyResult.projectAccess["poke-man"].enabled = true;
          }
        });
      }

      return emptyResult;

    } catch (e) {
      console.error("Error loading project & dataset access:", e);
      return {
        accessLevel: "",
        projectAccess: {
          "winter-soldier": { enabled: false, datasets: [] },
          "summer-warrior": { enabled: false, datasets: [] },
          "poke-man": { enabled: false }
        }
      };
    }
  };

  useEffect(() => {
    if (!user) {
      setUserState({
        username: "",
        email: "",
        password: "",
        accessLevel: "",
        callAccess: false,
        canView: false,
        canEdit: false,
        projectAccess: {
          "winter-soldier": { enabled: false, datasets: [] },
          "summer-warrior": { enabled: false, datasets: [] },
          "poke-man": { enabled: false }
        }
      });
      setErrors({});
      return;
    }
    const email = user.Attributes?.find(a => a.Name === "email")?.Value || "";

    const empAttr = user.Attributes?.find(
      a => a.Name === "custom:empInfo"
    );
console.log("CUSTOM EMP INFO:", empAttr?.Value);
    const empInfo = JSON.parse(empAttr?.Value || "{}");

    const { accessLevel, callAccess, canView, canEdit, projectAccess } = loadProjectAccess(user);

    setUserState({
      username: empInfo.name || "",
      email,
      password: "",
      accessLevel,
      callAccess,
      canView,
      canEdit,
      projectAccess
    });

    setErrors({});
  }, [user]);

  const toggleDataset = (project, datasetId) => {
    if (!isAdmin) return;

    setUserState(prev => {
      const existing = prev.projectAccess[project].datasets || [];
      return {
        ...prev,
        projectAccess: {
          ...prev.projectAccess,
          [project]: {
            ...prev.projectAccess[project],
            datasets: existing.includes(datasetId)
              ? existing.filter(id => id !== datasetId)
              : [...existing, datasetId]
          }
        }
      };
    });
  };

  const toggleIfAdmin = (key) => {
    if (!isAdmin) {
      showAlert("Only admin can edit project access", [
        { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
      ]);
      return;
    }

    setUserState(prev => {
      const currentlyEnabled = prev.projectAccess[key].enabled;

      return {
        ...prev,
        projectAccess: {
          ...prev.projectAccess,
          [key]: {
            ...prev.projectAccess[key],
            enabled: !currentlyEnabled,
            datasets: currentlyEnabled ? [] : prev.projectAccess[key].datasets
          }
        }
      };
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "callAccess") {
      setUserState(prev => ({ ...prev, callAccess: checked }));
      return;
    }
    if (name === "canView") {
      setUserState(prev => ({ ...prev, canView: checked }));
      return;
    }
    if (name === "canEdit") {
      setUserState(prev => ({ ...prev, canEdit: checked }));
      return;
    }
    if (name === "username") {

      const limitedValue = value.slice(0, 50);

      if (value.length > 50) {
        setErrors(prev => ({
          ...prev,
          username: "Username cannot exceed 50 characters"
        }));
      } else {
        setErrors(prev => ({
          ...prev,
          username: ""
        }));
      }

      setUserState(prev => ({
        ...prev,
        username: limitedValue
      }));

      return;
    }

    if (name === "accessLevel") {
      setUserState(prev => ({
        ...prev,
        accessLevel: value,
        callAccess: value === "1" ? true : value === "2"   ? false: false,
        canView: value === "1" ? true :  value === "2"   ? false: false,
        canEdit: value === "1" ? true :  value === "2"   ? false: false,

        // If Admin selected, clear dataset selections
        projectAccess:
          value === "1" || value === "Admin"
            ? {
              ...prev.projectAccess,
              "winter-soldier": {
                ...prev.projectAccess["winter-soldier"],
                datasets: []
              },
              "summer-warrior": {
                ...prev.projectAccess["summer-warrior"],
                datasets: []
              }
            }
            : prev.projectAccess
      }));
    } else {
      setUserState(prev => ({
        ...prev,
        [name]: value
      }));
    }

    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const original = user
    ? loadProjectAccess(user)
    : { accessLevel: "", projectAccess: {} };

  const isAnythingChanged =
    !isEditMode ||
    userState.email !== (user?.Attributes?.find(a => a.Name === "email")?.Value || "") ||
    userState.accessLevel !== original.accessLevel ||
    userState.callAccess !== (original.callAccess ?? false) ||
    userState.canView !== (original.canView ?? false) ||
    userState.canEdit !== (original.canEdit ?? false) ||
    JSON.stringify(userState.projectAccess) !== JSON.stringify(original?.projectAccess);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -])[A-Za-z\d\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -]{8,}$/;

  const validateForm = () => {
    const nextErrors = {};

    if (!userState.username.trim()) nextErrors.username = "Username is required";

    if (!userState.email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!emailRegex.test(userState.email)) {
      nextErrors.email = "Please enter a valid email address";
    }

    if (!isEditMode) {
      if (!userState.password) {
        nextErrors.password = "Password is required";
      } else if (userState.password !== userState.password.trim()) {
        nextErrors.password = "Password cannot start or end with a space";
      } else if (/\s{2,}/.test(userState.password)) {
        nextErrors.password = "Password cannot contain multiple consecutive spaces";
      } else if (!passwordRegex.test(userState.password)) {
        nextErrors.password =
          "Password must be at least 8 characters and include uppercase, lowercase, number, and special character";
      }
    }

    if (!userState.accessLevel) nextErrors.accessLevel = "Access level is required";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    if (isEditMode && !isAnythingChanged) {
      showToast({ message: "No changes to save" });
      return;
    }

    let apiName = '';
    let method = '';
    let activityId = '';
    try {
      hud("Please Wait...");

      if (isEditMode) {
        apiName = 'WS_Cognito_UserAttributes_UPDATE';
        method = 'UPDATE';
        activityId = user?.Username || '';
        // Preserve existing empInfo
        const empAttr = user.Attributes?.find(a => a.Name === "custom:empInfo");

        let existingEmpInfo = {};
        try {
          existingEmpInfo = empAttr?.Value ? JSON.parse(empAttr.Value) : {};
        } catch {
          existingEmpInfo = {};
        }

        const updatedEmpInfo = {
          ...existingEmpInfo,
          accessLevel: parseInt(userState.accessLevel, 10),
          projectAccess: userState.projectAccess,
          isEmployeeApproved: empInfo.isEmployeeApproved,
          isEmployeeActive: empInfo.isEmployeeActive
        };

        // Admin
        if (userState.accessLevel === "1") {
          updatedEmpInfo.callAccess = true;
          updatedEmpInfo.canView = true;
          updatedEmpInfo.canEdit = true;
        }

        // Manager
        else if (userState.accessLevel === "2") {
          updatedEmpInfo.callAccess = userState.callAccess;
          updatedEmpInfo.canView = userState.canView;
          updatedEmpInfo.canEdit = userState.canEdit;
        }

        // Employee
        else if (userState.accessLevel === "3") {
          delete updatedEmpInfo.callAccess;
          delete updatedEmpInfo.canView;
          delete updatedEmpInfo.canEdit;
        }
        const updatePayload = {
          username: user.Username,
          attributes: [
            {
              Name: "email",
              Value: userState.email
            },
            {
              Name: "custom:empInfo",
              Value: JSON.stringify(updatedEmpInfo)
            },
          ]
        };

        console.log("HITTING WS_Cognito_UserAttributes_UPDATE", updatePayload);

        const response = await usersDS.WS_Cognito_UserAttributes_UPDATE(updatePayload);
        console.log("WS_Cognito_UserAttributes_UPDATE Response :", response)

        const data = response?.data ?? response;

        const parsedBody =
          typeof data.body === "string"
            ? JSON.parse(data.body)
            : data.body;

        if (data.statusCode === 200) {

          if (isAnythingChanged) {
            const email = user.Attributes?.find(a => a.Name === "email")?.Value || user.Username;

            insertLog(
              `${emailaddedby} updated user ${email}`,
              0,
              emailaddedby,
              hud,
              stopHudRotation,
              showAlert,
              user.Username || '',
              'UPDATE',
              'WS_Cognito_UserAttributes_UPDATE',
              'SUCCESS',
              ''
            );

          }

          showToast({ message: "User updated successfully!" });

        } else {
          console.log("WS_Cognito_UserAttributes_UPDATE Error :", parsedBody?.message || parsedBody?.error);
          showAlert("Failed to update user",
            [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
          );
          insertLog(
            `${emailaddedby} failed to update user '${user.Username}'`,
            0,
            emailaddedby,
            hud,
            stopHudRotation,
            showAlert,
            user.Username || '',
            'UPDATE',
            'WS_Cognito_UserAttributes_UPDATE',
            'FAILED',
            'Unable to update user'
          );
          return;
        }
      }
      else {
        apiName = 'WS_Congnito_User_Add';
        method = 'INSERT';
        activityId = userState.email || '';
        const projectAccessPayload = [];

        if (userState.projectAccess["winter-soldier"]?.enabled) {
          projectAccessPayload.push({
            wintersoldier: true,
            datasets: (userState.projectAccess["winter-soldier"].datasets || []).map(String)
          });
        }


        if (userState.projectAccess["summer-warrior"].enabled) {
          projectAccessPayload.push({
            summerwarrior: true,
            "datasets": (userState.projectAccess["summer-warrior"].datasets || []).map(String)
          });
        }
        if (userState.projectAccess["poke-man"].enabled) {
          projectAccessPayload.push({
            "poke-man": true
          });
        }
        console.log("UserState:", userState);
        const addPayload = {
          name: userState.username,
          email: userState.email,
          password: userState.password,
          accessLevel: ACCESS_LEVEL[userState.accessLevel].add,
          callAccess: userState.callAccess,
          canView: userState.canView,
          canEdit: userState.canEdit,
          isEmployeeApproved: true,
          isEmployeeActive: true,
          projectAccess: {
            "winter-soldier": {
              enabled: !!userState.projectAccess["winter-soldier"]?.enabled,
              datasets: userState.projectAccess["winter-soldier"]?.datasets || []
            },
            "summer-warrior": {
              enabled: !!userState.projectAccess["summer-warrior"]?.enabled,
              datasets: userState.projectAccess["summer-warrior"]?.datasets || []
            },
            "poke-man": {
              enabled: !!userState.projectAccess["poke-man"]?.enabled
            }
          },
          created_by_email_id: useremail
        };
        // Admin
        if (userState.accessLevel === "1") {
          addPayload.callAccess = true;
          addPayload.canView = true;
          addPayload.canEdit = true;
        }

        // Manager
        else if (userState.accessLevel === "2") {
          addPayload.callAccess = userState.callAccess;
          addPayload.canView = userState.canView;
          addPayload.canEdit = userState.canEdit;
        }

        console.log("WS_Congnito_User_Add Request Data:", JSON.stringify(addPayload, null, 2));

        const response = await usersDS.WS_Congnito_User_Add(addPayload);
        console.log("WS_Congnito_User_Add Response :", response);

        const data = response?.data ?? response;
        const statusCode = data?.statusCode || data?.data?.statusCode;
        const message = data?.body || data?.data?.body;

        if (statusCode === 200 || response?.status === 200) {
          showToast({
            message: "User Created Successfully!"
          });
          insertLog(
            `${emailaddedby} added new user ${userState.email}`,
            0,
            emailaddedby,
            hud,
            stopHudRotation,
            showAlert,
            userState.email || '',
            'INSERT',
            'WS_Congnito_User_Add',
            'SUCCESS',
            ''
          );
        } else {
          console.log("WS_Cognito_User_Add Error :", message);
          showAlert(message || "Failed to create user",
            [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]
          );
          insertLog(
            `${emailaddedby} failed to create user '${userState.email}'`,
            0,
            emailaddedby,
            hud,
            stopHudRotation,
            showAlert,
            userState.email || '',
            'INSERT',
            'WS_Congnito_User_Add',
            'FAILED',
            'Unable to create user'
          );
          return;
        }
      }

      usersList?.();
      onClose();

    } catch (e) {
      insertLog(
        `${emailaddedby} failed to ${method === 'UPDATE' ? 'update user' : 'add user'} ${activityId}`,
        0,
        emailaddedby,
        hud,
        stopHudRotation,
        showAlert,
        activityId,
        method,
        apiName,
        'FAILED',
        e.message
      );

      console.error("Save user failed:", e);

      const errorMessage =
        e?.message || e?.response?.data?.message || "Failed to save user";

      showAlert(errorMessage, [
        { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
      ]);
    }
    finally {
      stopHudRotation();
    }
  };

  const selectAllDatasets = (project) => {
    if (!Array.isArray(datasets)) return;

    const allIds = datasets.map(ds => ds.datasetID);
    setUserState(prev => ({
      ...prev,
      projectAccess: {
        ...prev.projectAccess,
        [project]: {
          ...prev.projectAccess[project],
          datasets: allIds
        }
      }
    }));
  };

  const deselectAllDatasets = (project) => {
    setUserState(prev => ({
      ...prev,
      projectAccess: {
        ...prev.projectAccess,
        [project]: {
          ...prev.projectAccess[project],
          datasets: []
        }
      }
    }));
  };

  return {
    showPassword,
    setShowPassword,
    userState,
    empInfo,
    setUserState,
    errors,
    setErrors,
    isAdmin,
    toggleDataset,
    toggleIfAdmin,
    handleChange,
    handleSave,
    selectAllDatasets,
    deselectAllDatasets,
    ACCESS_LEVEL,
    normalizeAccessLevel,
    loadProjectAccess,
    isEditMode,
    isAnythingChanged
  };
}